import { useEffect, useState } from "react";
import { CloudOff, RefreshCw } from "lucide-react";

export default function OfflineIndicator() {
  const [online, setOnline] = useState(navigator.onLine);
  const [pending, setPending] = useState(0);

  useEffect(() => {
    const handleOnline = () => setOnline(true);
    const handleOffline = () => setOnline(false);
    window.addEventListener("online", handleOnline);
    window.addEventListener("offline", handleOffline);
    const refreshPending = () => {
      const q = JSON.parse(localStorage.getItem("offline_queue") || "[]");
      setPending(q.length);
    };
    refreshPending();
    const onUpdate = () => refreshPending();
    window.addEventListener("offline-queue-changed", onUpdate);
    const interval = setInterval(refreshPending, 5000);
    return () => {
      window.removeEventListener("online", handleOnline);
      window.removeEventListener("offline", handleOffline);
      window.removeEventListener("offline-queue-changed", onUpdate);
      clearInterval(interval);
    };
  }, []);

  if (online && pending === 0) return null;

  return (
    <div data-testid="offline-indicator"
         className="fixed top-2 left-1/2 -translate-x-1/2 z-[60] flex items-center gap-1.5 px-3 py-1.5 rounded-full text-[11px] font-medium shadow-lg"
         style={{
           background: online ? "linear-gradient(135deg,#F59E0B 0%,#F97316 100%)" : "linear-gradient(135deg,#0F172A 0%,#334155 100%)",
           color: "#fff",
         }}>
      {online ? (
        <>
          <RefreshCw size={11} className="animate-spin" /> Sincronizando {pending}
        </>
      ) : (
        <>
          <CloudOff size={11} /> Offline · {pending > 0 && `${pending} fila`}
        </>
      )}
    </div>
  );
}
